"use strict";

// ===========================================
//  library
// ===========================================
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initializeLenis } from "../../utility/_lenis";
import { initializeWebgl } from "../../utility/_initializeWebgl";
import { initializeKvAnimatePrism } from "../../utility/_kvPrism";
import { initializeKvSections } from "../../utility/_gsap";

// ===========================================
//  variable
// ===========================================

// ===========================================
//  setup
// ===========================================
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  initializeLenis();
  initializeKvSections();
});
initializeWebgl();
initializeKvAnimatePrism();
